import * as yup from 'yup'

// Blank box = "keep the stored value", so it is allowed and dropped on submit
const optionalPositiveInt = yup
  .number()
  .transform((value, original) =>
    original === '' || original === null ? undefined : value,
  )
  .typeError('Must be a number')
  .integer('Must be a whole number')
  .min(1, 'Must be at least 1')
  .optional()

export const alertConfigSchema = yup.object().shape({
  alert: yup.object({
    isEnabled: yup.boolean(),
    url: yup
      .string()
      .trim()
      .url('Invalid URL')
      .when('isEnabled', {
        is: true,
        then: (schema) => schema.required('URL is required when enabled'),
      }),
    bearerToken: yup.string().trim(),
  }),
  notificationChannels: yup.object({
    alert: yup.boolean(),
    sms: yup.boolean(),
    email: yup.boolean(),
    fallback: yup.boolean(),
  }),
  aggregatorApiMaxHoursWithoutRun: optionalPositiveInt,
  sapConnectionAlertThrottleMinutes: optionalPositiveInt,
  sapOrderUnsyncedAlertHours: optionalPositiveInt,
  sapReconUnsyncedAlertHours: optionalPositiveInt,
  sapRmaUnsyncedAlertHours: optionalPositiveInt,
  sapInventoryMaxHoursWithoutRun: optionalPositiveInt,
  freshInventoryMaxHoursWithoutRun: optionalPositiveInt,
  instashopLastMileDelayAlertWindow: optionalPositiveInt,
  notificationFallbackThrottleMinutes: optionalPositiveInt,
})

export type AlertConfigFormFields = yup.InferType<typeof alertConfigSchema>
